// extracted by mini-css-extract-plugin
export default {"syncIcon":"app-assets-javascripts-components-statusBadge-statusBadge__syncIcon--OuwWk","rotating":"app-assets-javascripts-components-statusBadge-statusBadge__rotating--PfL4D"};